import React, { useState, useEffect, useRef } from "react";
import { FaMicrophone, FaPlus, FaFacebookF, FaTwitter, FaInstagram } from "react-icons/fa";
import { useNavigate, useParams, useLocation } from "react-router-dom";

const blue = "#08306b";
const yellow = "#fffd33";

function EditCocktailPage() {
  const { cocktailId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const cocktailFromState = location.state?.cocktail;

  const [cocktails, setCocktails] = useState([]);
  const [bars, setBars] = useState([]);
  const [selectedBar, setSelectedBar] = useState("");
  const [cocktailIdState, setCocktailIdState] = useState(null);

  const [cocktailNameGr, setCocktailNameGr] = useState("");
  const [flavorGr, setFlavorGr] = useState("");
  const [ingredientsGr, setIngredientsGr] = useState([""]);
  const [audioFileGr, setAudioFileGr] = useState(null);

  const [cocktailNameEn, setCocktailNameEn] = useState("");
  const [flavorEn, setFlavorEn] = useState("");
  const [ingredientsEn, setIngredientsEn] = useState([""]);
  const [audioFileEn, setAudioFileEn] = useState(null);

  const [price, setPrice] = useState("");

  const audioInputGrRef = useRef();
  const audioInputEnRef = useRef();



useEffect(() => {
  if (cocktailFromState) {
    setSelectedBar(cocktailFromState.bar || "");

    setCocktailNameEn(cocktailFromState.name?.en || "");
    setFlavorEn(cocktailFromState.description?.en || "");
    setIngredientsEn(cocktailFromState.ingredients?.en || []);
    setCocktailIdState(cocktailFromState.id || null);

    setCocktailNameGr(cocktailFromState.name?.gr || "");
    setFlavorGr(cocktailFromState.description?.gr || "");
    setIngredientsGr(cocktailFromState.ingredients?.gr || []);

    setPrice(cocktailFromState.price?.replace("€", "") || "");
  }
}, [cocktailFromState]);

  const handleBack = () => {
    navigate("/manage-bars");
  };

  const handleAddIngredient = (lang) => {
    if (lang === "gr") setIngredientsGr([...ingredientsGr, ""]);
    else setIngredientsEn([...ingredientsEn, ""]);
  };

  const handleIngredientChange = (lang, index, value) => {
    const update = (list, setter) => {
      const updated = [...list];
      updated[index] = value;
      setter(updated);
    };
    if (lang === "gr") update(ingredientsGr, setIngredientsGr);
    else update(ingredientsEn, setIngredientsEn);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("currentName",cocktailNameEn );
    formData.append("id", cocktailIdState);

    formData.append("bar_name", selectedBar);
    formData.append("name_en", cocktailNameEn);
    formData.append("description_en", flavorEn);
    formData.append("name_gr", cocktailNameGr);
    formData.append("description_gr", flavorGr);
    formData.append("ingredients_en", JSON.stringify(ingredientsEn));
    formData.append("ingredients_gr", JSON.stringify(ingredientsGr));
    formData.append("price", parseFloat(price.replace(/[^\d.]/g, "")));

    console.log("🎙️ Audio EN:", audioFileEn);
    console.log("🎙️ Audio GR:", audioFileGr);
    if (audioFileEn) formData.append("voice_en", audioFileEn);
    if (audioFileGr) formData.append("voice_gr", audioFileGr);

    for (let pair of formData.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/cocktails`, {
        method: "PUT",
        body: formData,
      });

      if (!response.ok) throw new Error("Update failed");

      const result = await response.json();
      console.log("✅ Cocktail updated:", result);
      alert("Cocktail updated successfully!");
      navigate("/admin");
    } catch (error) {
      console.error("❌ Update error:", error);
      alert("Failed to update cocktail.");
    }
};

  return (
    <div style={styles.container}>
      <button style={styles.back} onClick={handleBack}>←</button>
      <h1 style={styles.title}>Edit Cocktail</h1>
      <form style={styles.form} onSubmit={handleSubmit}>
        {/* <label style={styles.label}>Select Cocktail Bar</label>
        <select
          value={selectedBar}
          onChange={(e) => setSelectedBar(e.target.value)}
          style={styles.select}
        >
          <option value="" disabled>Select a bar</option>
          {bars.map((bar) => (
            <option key={bar.id} value={bar.name}>
              {bar.name}
            </option>
          ))}
        </select> */}

        <div style={styles.row}>
          <div style={styles.column}>
            <h3 style={styles.subTitle}>Greek (GR)</h3>
            <label style={styles.label}>Cocktail Name</label>
            <input
              type="text"
              value={cocktailNameGr}
              onChange={(e) => setCocktailNameGr(e.target.value)}
              style={styles.input}
            />
            <label style={styles.label}>Description</label>
            <textarea
              value={flavorGr}
              onChange={(e) => setFlavorGr(e.target.value)}
              style={styles.textarea}
            />
            <label style={styles.label}>Ingredients</label>
            {ingredientsGr.map((item, index) => (
              <input
                key={index}
                value={item}
                onChange={(e) => handleIngredientChange("gr", index, e.target.value)}
                style={styles.input}
              />
            ))}
            <button type="button" onClick={() => handleAddIngredient("gr")} style={styles.addButton}>
              <FaPlus style={{ marginRight: 6 }} /> Add Ingredient
            </button>
            <label style={styles.label}>Voice Message (GR)</label>
            <input
              type="file"
              accept=".mp3"
              ref={audioInputGrRef}
              style={{ display: "none" }}
              id="voice-gr"
              onChange={(e) => setAudioFileGr(e.target.files[0])}
            />
            <label htmlFor="voice-gr" style={styles.uploadButton}>
              <FaMicrophone style={{ marginRight: 8 }} />
              Upload GR Voice
            </label>
          </div>

          <div style={styles.column}>
            <h3 style={styles.subTitle}>English (EN)</h3>
            <label style={styles.label}>Cocktail Name</label>
            <input
              type="text"
              value={cocktailNameEn}
              onChange={(e) => setCocktailNameEn(e.target.value)}
              style={styles.input}
            />
            <label style={styles.label}>Description</label>
            <textarea
              value={flavorEn}
              onChange={(e) => setFlavorEn(e.target.value)}
              style={styles.textarea}
            />
            <label style={styles.label}>Ingredients</label>
            {ingredientsEn.map((item, index) => (
              <input
                key={index}
                value={item}
                onChange={(e) => handleIngredientChange("en", index, e.target.value)}
                style={styles.input}
              />
            ))}
            <button type="button" onClick={() => handleAddIngredient("en")} style={styles.addButton}>
              <FaPlus style={{ marginRight: 6 }} /> Add Ingredient
            </button>
            <label style={styles.label}>Voice Message (EN)</label>
            <input
              type="file"
              accept=".mp3"
              ref={audioInputEnRef}
              style={{ display: "none" }}
              id="voice-en"
              onChange={(e) => setAudioFileEn(e.target.files[0])}
            />
            <label htmlFor="voice-en" style={styles.uploadButton}>
              <FaMicrophone style={{ marginRight: 8 }} />
              Upload EN Voice
            </label>
          </div>
        </div>

        <label style={styles.label}>Price (€)</label>
        <input
          type="text"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          style={styles.input}
        />

        <button type="submit" style={styles.submit}>Save Changes</button>
      </form>

      <footer style={styles.footer}>
        <div style={styles.socials}>
          <a href="https://facebook.com" target="_blank" rel="noreferrer" style={styles.iconLink}><FaFacebookF /></a>
          <a href="https://twitter.com" target="_blank" rel="noreferrer" style={styles.iconLink}><FaTwitter /></a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer" style={styles.iconLink}><FaInstagram /></a>
        </div>
        <p style={styles.footerText}>© 2024 Created & Published by</p>
        <p style={styles.footerText}><strong>METRON ARISTON</strong> · Making Responsibility a Trend™</p>
      </footer>
    </div>
  );
}

const styles = {
    container: {
      background: blue,
      padding: "60px 20px 30px",
      fontFamily: "'Segoe UI', sans-serif",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      color: yellow,
    },
    title: {
      fontSize: "30px",
      marginBottom: "30px",
      color: yellow,
      textAlign: "center",
    },
    subTitle: {
      color: blue,
      fontSize: "18px",
      fontWeight: "bold",
      marginBottom: "10px",
    },
    form: {
      background: "#fff",
      borderRadius: "16px",
      padding: "40px",
      maxWidth: "900px",
      width: "100%",
      boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)",
      display: "flex",
      flexDirection: "column",
      gap: "18px",
      marginBottom: "40px",
    },
    row: {
      display: "flex",
      gap: "20px",
      justifyContent: "space-between",
      flexWrap: "wrap",
    },
    column: {
      flex: 1,
      minWidth: "280px",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    label: {
      color: blue,
      fontWeight: "500",
      fontSize: "15px",
      textAlign: "left",
    },
    input: {
      padding: "12px",
      fontSize: "15px",
      border: "1px solid #ccc",
      borderRadius: "8px",
      outline: "none",
    },
    textarea: {
      padding: "12px",
      fontSize: "15px",
      border: "1px solid #ccc",
      borderRadius: "8px",
      height: "100px",
      resize: "none",
      outline: "none",
    },
    submit: {
      padding: "14px",
      backgroundColor: yellow,
      color: blue,
      border: "none",
      borderRadius: "8px",
      fontWeight: "bold",
      fontSize: "16px",
      cursor: "pointer",
      marginTop: "10px",
    },
    addButton: {
      padding: "10px 14px",
      backgroundColor: "transparent",
      color: blue,
      border: `2px solid ${blue}`,
      borderRadius: "8px",
      fontWeight: "bold",
      fontSize: "14px",
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      width: "fit-content",
      marginTop: "-8px",
    },
    uploadButton: {
      padding: "10px 14px",
      backgroundColor: yellow,
      color: blue,
      border: "none",
      borderRadius: "8px",
      fontWeight: "bold",
      fontSize: "14px",
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "8px",
    },
    fileName: {
      marginTop: "6px",
      fontSize: "14px",
      color: blue,
    },
    footer: {
      textAlign: "center",
      color: "#eee",
      marginTop: "auto",
      paddingBottom: "20px",
    },
    socials: {
      display: "flex",
      justifyContent: "center",
      gap: "20px",
      fontSize: "20px",
      marginBottom: "10px",
    },
    iconLink: {
      color: yellow,
      textDecoration: "none",
    },
    footerText: {
      fontSize: "13px",
      margin: "4px 0",
    },
    select: {
      padding: "12px",
      fontSize: "15px",
      border: "1px solid #ccc",
      borderRadius: "8px",
      outline: "none",
      backgroundColor: "#fff",
      color: "#000",
    },
    back: {
      alignSelf: "flex-start",
      fontSize: "24px",
      background: "none",
      border: "none",
      color: yellow,
      cursor: "pointer",
      marginBottom: "20px",
    },
  };  

export default EditCocktailPage;